KMVP.feedbackModal = {
    isModalBlocked: function() {
        return $('.js-quote-feedback-modal').hasClass('form-blocked');
    },
    bindOnChange: function() {
        function resetTextareaError() {
            KMVP.feedbackModal.markTextareaAsValid();
        }
        $('.js-feedback-reason').change(resetTextareaError);
        $('.js-feedback-comment').on('input', resetTextareaError);
    },
    bindGiveFeedbackButton: function() {
        $(document).on('click', '.js-quote-feedback-modal .js-send-feedback-button', function() {

            var reason = $('.js-feedback-reason').val();
            var comment = $('.js-feedback-comment').val();


            if (KMVP.feedbackModal.isModalBlocked()) {
                return;
            }

            // Empty comment is not allowed for reason "other"
            if (reason === "OTHER" && !comment) {
                KMVP.feedbackModal.markTextareaAsInvalid();
                return;
            } else {
                KMVP.feedbackModal.markTextareaAsValid();
            }

            KMVP.feedbackModal.blockModal();
            $.ajax({
                url: $(this).data('quoteFeedbackUrl'),
                type: "POST",
                data: {
                    rejectReason: reason,
                    comment: comment
                },
                success: function (data) {
                    KMVP.feedbackModal.closeModal();
                    KMVP.kmcQuoteCommon.showQuoteConfirmation(data);
                },
                complete: function () {
                    KMVP.feedbackModal.unblockModal();
                }
            });
        });
    },
    markTextareaAsInvalid: function() {
        $('.js-feedback-comment').addClass('is-invalid');
    },
    markTextareaAsValid: function() {
        $('.js-feedback-comment').removeClass('is-invalid');
    },
    blockModal: function() {
        $('.js-quote-feedback-modal').addClass('form-blocked');
    },
    unblockModal: function() {
        $('.js-quote-feedback-modal').removeClass('form-blocked');
    },
    closeModal: function() {
        $('.js-quote-feedback-modal').modal('toggle');
    }
};

$(document).ready(function () {
    KMVP.feedbackModal.bindOnChange();
    KMVP.feedbackModal.bindGiveFeedbackButton();
    $('#cboxOverlay').remove();
    $('#colorbox').remove();
});
